export default function initOpenClose() {
  Alpine.data('openClose', (defaultState: boolean | undefined) => ({
    open: defaultState === undefined ? false : defaultState,
    openDialog() {
      this.open = true;
    },
    closeDialog() {
      this.open = false;
    },
  }));
}
